import {IBusinessAreaFields} from "../@types/contentful";

export const modifyAutocompleteSearchResults = (arr: any[], jobCategories: IBusinessAreaFields[] ) => {
  const items = arr
    .map(el => el.items.map((item: any) => ({
      ...item,
      source: el.source,
    })))
    .flat()
    .map(item => ({
      ...item,
      query: item?.query ? item.query.replace(/[a]*$/, '') : null,
    }))
    .filter((thing, index, self) =>{
      if(thing.source.sourceId !== 'products') {
        return index === self.findIndex((t) => (
          t.query && thing.query ? t.query.toLowerCase().trim() === thing.query.toLowerCase().trim() : false
        ));
      }

      return true;
    });

  const modifiedGroups = items.map((algoliaItem: any) => {
    if (algoliaItem && algoliaItem.source?.sourceId === 'products') {
      const contentfulItem = jobCategories?.find((item: IBusinessAreaFields) => item?.tag?.toLowerCase() === algoliaItem.group.toLowerCase());
      if (!contentfulItem) return null;
      algoliaItem.groupLabel = contentfulItem?.label;

      return algoliaItem;
    }

    return algoliaItem;
  })
    .filter((el: any) => el !== null)
    .sort((a, b) => a.hasOwnProperty("title") ? -1 : b.hasOwnProperty("title") ? 1 : 0);

  return modifiedGroups;
};